export const TOURNAMENT_TITLE_BLOCK = 'tournament_title_block';
export const TOURNAMENTS_TABLE = 'tournaments_table';
export const TOURNAMENT_EVENTS = 'tournament_events';
export const TOURNAMENT_INFO = 'tournament_info';
export const TOURNAMENT_LOGO = 'tournament_logo';
